import { Field, NumericInput } from 'Components/Core';
import { withInjectedProps } from 'Components/Core/InjectedPropsContext';
import { ListFieldSection } from 'Components/Layout';
import { WorksheetEquipmentDropdown } from 'Components/Worksheets/Core';

let AsLinearShrinkageEquipmentSection: React.FC = () => {
  return (
    <>
      <ListFieldSection heading="Shrinkage Equipment">
        <Field input={<WorksheetEquipmentDropdown />} equipmentType="measure" name="Preparation.Measure" />
        <Field input={<WorksheetEquipmentDropdown />} equipmentType="caliper" name="Preparation.Caliper" />
        <Field
          input={<WorksheetEquipmentDropdown />}
          equipmentType="shrinkage-mould"
          name="Preparation.ShrinkageMould"
        />
        <Field input={<NumericInput />} name="Preparation.InternalLengthOfMould" />
      </ListFieldSection>
    </>
  );
};

AsLinearShrinkageEquipmentSection = withInjectedProps(AsLinearShrinkageEquipmentSection);

export default AsLinearShrinkageEquipmentSection;
